module.exports = __webpack_public_path__ + "assets/icons/my-jobs.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/my-jobs.png
// module id = ./src/styles/icons/sidemenu/my-jobs.png
// module chunks = 0